import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function setName(name) {
  return localStorage.setItem('name', name)
}
export function getName() {
  return localStorage.getItem('name')
}
export function removeName() {
  return localStorage.removeItem('name')
}
export function setAddress(address) {
  return localStorage.setItem('address', address)
}
export function getAddress() {
  return localStorage.getItem('address')
}
export function removeAddress() {
  return localStorage.removeItem('address')
}
export function setStatus(status) {
  return localStorage.setItem('status', status)
}
export function getStatus() {
  return localStorage.getItem('status')
}
export function removeStatus() {
  return localStorage.removeItem('status')
}
export function setMobile(mobile) {
  return localStorage.setItem('mobile', mobile)
}
export function getMobile() {
  return localStorage.getItem('mobile')
}
export function setPermission(permission) {
  return localStorage.setItem('permission', permission)
}
export function getPermission() {
  return JSON.parse(localStorage.getItem('permission'))
}
export function removePermission() {
  return localStorage.removeItem('permission')
}
export function getLanguage() {
  return sessionStorage.getItem('language')
}